
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    navTitle: 'Digital content',
    title: 'Important terms for receiving digital content',
    item1: 'there is no physical delivery of digital content;',
    item2: 'the service provides exclusively digital content;',
    item3: 'digital items are provided inside the platform;',
    item4: "individual items can be withdrawn by the user to their own Steam account;",
    item5: 'item transfer happens automatically;',
    item6:
      'transfer times may increase due to technical limitations of Steam or a security check.',
  },
  ru: {
    navTitle: 'Получение цифрового контента',
    title: 'Важные условия получения цифрового контента',
    item1: 'физическая доставка цифрового контента отсутствует;',
    item2: 'сервис предоставляет исключительно цифровой контент;',
    item3: 'цифровые предметы предоставляются внутри платформы;',
    item4: 'отдельные предметы могут быть выведены пользователем на собственный аккаунт Steam;',
    item5: 'передача предметов происходит автоматически;',
    item6:
      'сроки передачи могут увеличиваться из-за технических ограничений Steam либо проверки безопасности.',
  },
  uz: {
    navTitle: 'Raqamli kontent olish',
    title: 'Raqamli kontent olishning muhim shartlari',
    item1: 'raqamli kontentning jismoniy yetkazib berilishi mavjud emas;',
    item2: 'servis faqat raqamli kontent taqdim etadi;',
    item3: 'raqamli buyumlar platforma ichida taqdim etiladi;',
    item4: 'ayrim buyumlar foydalanuvchi tomonidan oʻzining Steam akkauntiga chiqarilishi mumkin;',
    item5: 'buyumlarni oʻtkazish avtomatik ravishda amalga oshiriladi;',
    item6:
      'oʻtkazish muddatlari Steam texnik cheklovlari yoki xavfsizlik tekshiruvi tufayli uzayishi mumkin.',
  },
  fa: {
    navTitle: 'محتوای دیجیتال',
    title: 'شرایط مهم دریافت محتوای دیجیتال',
    item1: 'محتوای دیجیتال تحویل فیزیکی ندارد؛',
    item2: 'سرویس فقط محتوای دیجیتال ارائه می‌دهد؛',
    item3: 'آیتم‌های دیجیتال داخل پلتفرم داده می‌شوند؛',
    item4: 'کاربر می‌تواند بعضی آیتم‌ها را به حساب استیم خودش برداشت کند؛',
    item5: 'انتقال آیتم خودکار انجام می‌شود؛',
    item6: 'محدودیت‌های فنی استیم یا بررسی امنیتی می‌تواند زمان انتقال را طولانی کند.',
  },
  pt: {
    navTitle: 'Conteúdo digital',
    title: 'Condições importantes para receber conteúdo digital',
    item1: 'não há entrega física de conteúdo digital;',
    item2: 'o serviço fornece exclusivamente conteúdo digital;',
    item3: 'os itens digitais são fornecidos dentro da plataforma;',
    item4: 'itens específicos podem ser sacados pelo usuário para a própria conta Steam;',
    item5: 'a transferência de itens acontece automaticamente;',
    item6:
      'os prazos de transferência podem aumentar por limitações técnicas da Steam ou por uma verificação de segurança.',
  },
  tr: {
    navTitle: 'Dijital içerik',
    title: 'Dijital içerik almanın önemli koşulları',
    item1: 'dijital içeriğin fiziksel teslimatı yoktur;',
    item2: 'servis yalnızca dijital içerik sunar;',
    item3: 'dijital eşyalar platform içinde sunulur;',
    item4: 'bazı eşyalar kullanıcı tarafından kendi Steam hesabına çekilebilir;',
    item5: 'eşya aktarımı otomatik gerçekleşir;',
    item6:
      "aktarım süreleri Steam'in teknik kısıtlamaları ya da güvenlik kontrolü nedeniyle uzayabilir.",
  },
});
